const getCalendlyLink = ({ isExistingInvestor }) => {
  if (process.env.ENVIRONMENT === 'prod') {
    return isExistingInvestor
      ? 'https://calendly.com/av-investor-relations/ventureplan'
      : 'https://calendly.com/taf-team/venture-plan-discussion';
  }

  return isExistingInvestor
    ? 'https://calendly.com/chevaughn-av/30min-xx'
    : 'https://calendly.com/alex-critch/xx-15min';
};

export default getCalendlyLink;
